<template>
  <div class="c-after-block">
    <sq-nav :active-id="active"></sq-nav>
    <mt-tab-container
      :value="active"
      class="page-tabbar-tab-container"
    >
      <mt-tab-container-item :id="allId">
        <sq-live
          :data="allList.list"
          :top-func="allTop"
        >
          <div class="m-nomore fz12" v-show="allList.loading">加载中</div>
          <div style="height:9rem" v-show="allList.list.length === 0 && !allList.loading">
            <div class="m-nomore fz12">暂时没有</div>
          </div>
          <div v-show="allList.nomore && !allList.loading" class="m-nomore fz12">到底了，别扯了</div>
        </sq-live>
      </mt-tab-container-item>
      <mt-tab-container-item :id="eliteId">
        <sq-live
          :data="eliteList.list"
          :top-func="eliteTop"
        >
          <div class="m-nomore fz12" v-show="eliteList.loading">加载中</div>
          <div style="height: 9rem" v-show="eliteList.list.length === 0 && !eliteList.loading">
            <div class="m-nomore fz12">暂时没有</div>
          </div>
          <div v-show="eliteList.nomore && eliteList.list.length > 0" class="m-nomore fz12">到底了，别扯了</div>
        </sq-live>
      </mt-tab-container-item>
    </mt-tab-container>
  </div>
</template>

<script>
import Live from './live'
import Nav from './nav'
export default {
  components: {
    'sq-live': Live,
    'sq-nav': Nav
  },

  data () {
    return {
      allId: 'all',
      eliteId: 'elite'
    }
  },

  methods: {
    changeActive (name) {
      this.active = name
    },
    allTop (callback) {
      this.$store.dispatch('reload', callback)
    },
    allBottom () {
      this.$store.dispatch('getMoreAllBottomList')
    },
    eliteTop (callback) {
      // callback && callback ()
      this.$store.dispatch('reload', callback)
    },
    eliteBottom () {
      this.$store.dispatch('getEliteMoreInfo')
    },
    onscroll (e) {
      var isBottom = document.body.clientHeight <= window.scrollY + window.innerHeight + 100
      if (isBottom) {
        this.onBottomLoad()
      }
    },
    onBottomLoad () {
      if (this.active === this.allId && this.allList.list.length > 0) {
        this.allBottom()
      }
      if (this.active === this.eliteId && this.eliteList.list.length > 0) {
        this.eliteBottom()
      }
    }
  },

  computed: {
    headerInfo () {
      return this.$store.state.header
    },
    allList () {
      console.log(this.$store.state.list.all)
      return this.$store.state.list.all
    },
    eliteList () {
      return this.$store.state.list.elite
    },
    active () {
      return this.$store.state.list.activeId
    }
  },

  mounted () {
    document.addEventListener('scroll', this.onscroll, false)
    document.addEventListener('touchmove', this.onscroll, false)
  }

}
</script>



// WEBPACK FOOTER //
// content.vue?4664924b